/* global location, history */

import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Tools from "../tools";
import UserActions from "../../store/actions/userActions";
import constants from "../../common/constants";

export function useOidc(userManager, setEvaluated) {
  const dispatch = useDispatch();
  const userState = useSelector((state) => _.get(state, `user`));

  const isAuthenticated = useCallback(() => {
    if (userState.authenticated) {
      if (userState.details && userState.details.expired) {
        return false;
      }

      return true;
    }

    return false;
  }, [userState.authenticated, userState.details]);

  const isAuthorized = useCallback(() => {
    const roles = userState.details?.profile?.Roles;

    return !userState.error && Tools.includesOneOf(roles, constants.REQUIRED_ROLE);
  }, [userState.details, userState.error]);

  useEffect(() => {
    (async () => {
      if (isAuthenticated()) {
        setEvaluated(true);

        return;
      }

      if (await checkUserIfAlreadyCached(userManager, dispatch)) {
        setEvaluated(true);

        return;
      }

      const queryObject = Tools.queryStringToObject(window.location.search);

      if (queryObject.error) {
        handleIdpError(queryObject, dispatch);

        setEvaluated(true);

        return;
      }

      if (queryObject.code) {
        await handleAuthorizationCodeCallback(userManager);

        setEvaluated(true);

        return;
      }

      setEvaluated(true);
    })();
  }, [dispatch, isAuthenticated, userManager, setEvaluated]);

  return { isAuthenticated, isAuthorized };
}

function handleIdpError(queryObject, dispatch) {
  const error = queryObject.error;
  const errorDescription = queryObject.error_description;

  dispatch(UserActions.setLoggedIn({
    error: {
      error,
      errorDescription
    }
  }));
}

async function handleAuthorizationCodeCallback(userManager) {
  await userManager.signinRedirectCallback();

  history.replaceState({}, document.title, location.pathname);
}

async function checkUserIfAlreadyCached(userManager, dispatch) {
  const user = await userManager.getUser();

  if (user && !user.expired) {
    dispatch(UserActions.setLoggedIn({
      details: user
    }));

    return true;
  }

  return false;
}